import React from 'react';
import {Slider, Rail, Handles, Tracks} from 'react-compound-slider';

import {Handle, Track} from './components';
import styles from './ValueSlider.module.scss';

interface Props {
  progress: number;
  max: number;
  primaryColor?: string;
  secondaryColor?: string;
  onUpdate?(progress: number): void;
  onChange?(progress: number): void;
}

export default function ValueSlider({
  progress,
  max,
  primaryColor,
  secondaryColor,
  onUpdate,
  onChange,
}: Props) {
  // react-compund-slider requires these to be React.CSSProperties
  const sliderStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
  };

  const railStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    height: 5,
    borderRadius: 2.5,
    cursor: 'pointer',
    backgroundColor: secondaryColor ? secondaryColor : 'rgba(0,0,0, 0.1)',
  };

  const domain: number[] = [0, max];

  const handleChange = (values: readonly number[]) => {
    // onUpdate && onUpdate(values[0]);
    onChange && onChange(values[0]);
  };

  const handleUpdate = (values: readonly number[]) => {
    onUpdate && onUpdate(values[0]);
  };

  return (
    <div className={styles.SliderWrapper}>
      <Slider
        mode={1}
        step={1}
        domain={domain}
        rootStyle={sliderStyle}
        onChange={handleChange}
        onUpdate={handleUpdate}
        values={[progress]}
      >
        <Rail>
          {({getRailProps}) => <div style={railStyle} {...getRailProps()} />}
        </Rail>
        <Handles>
          {({handles, getHandleProps}) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={domain}
                  getHandleProps={getHandleProps}
                  color={primaryColor}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks right={false}>
          {({tracks, getTrackProps}) => (
            <div className="slider-tracks">
              {tracks.map(({id, source, target}) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                  color={primaryColor}
                />
              ))}
            </div>
          )}
        </Tracks>
      </Slider>
    </div>
  );
}
